export default __webpack_public_path__ + "static/icon-23-1-78ae060e30f5a0867e893979493982cf.png";